import React from 'react';
import profileImage from '../assests/login/ImageSeven.png';
import { HeroBackdrop } from './ui/BackgroundGraphics';
import StoreButtons from './ui/StoreButtons';

const PROOF_POINTS = [
  'Screenshots blocked — always on',
  'Public or discreet verification',
  'Approximate distance only — never exact location',
  'Zero data sold',
];

function Hero() {
  return (
    <HeroBackdrop className="min-h-[92vh] flex items-center py-20 md:py-28">
      <div className="site-container">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="animate-fade-up">
            <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-accent">
              🏳️‍🌈 Built by queer people · For queer people
            </span>

            <h1 className="text-4xl font-black leading-[1.02] tracking-tight text-white md:text-5xl lg:text-6xl xl:text-7xl">
              Hookups &amp; dating
              <br />
              <span className="text-primary">for gay &amp; queer people.</span>
              <br />
              <span className="text-white/90">Without the exposure.</span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-silver md:text-lg">
              StrapIn is privacy-first and trust-first — built so you can meet, date, and connect
              without compromising your safety, your closet, or your peace of mind.
            </p>

            <ul className="mt-8 space-y-3">
              {PROOF_POINTS.map((point) => (
                <li key={point} className="flex items-start gap-3 text-sm text-mist md:text-base">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/20 text-xs font-bold text-primary">
                    ✓
                  </span>
                  {point}
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <StoreButtons size="lg" />
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-[320px] animate-fade-up [animation-delay:150ms] lg:max-w-none lg:justify-self-end">
            <div className="absolute -left-8 top-8 hidden h-24 w-24 rounded-3xl border border-primary/20 bg-primary/10 blur-sm lg:block" aria-hidden />
            <div className="absolute -right-6 bottom-16 hidden h-20 w-20 rounded-full border border-secondary/20 bg-secondary/10 lg:block" aria-hidden />

            <div className="relative mx-auto w-[280px] overflow-hidden rounded-[2.5rem] border border-white/10 bg-surface shadow-phone">
              <div className="flex items-center justify-between border-b border-white/10 bg-graphite px-5 py-3">
                <span className="text-xs font-black uppercase tracking-wider text-white">Strapin</span>
                <span className="flex items-center gap-1.5 text-[0.65rem] text-mist">
                  <span className="h-1.5 w-1.5 rounded-full bg-green-500" />
                  Active now
                </span>
              </div>

              <div className="p-4">
                <div className="overflow-hidden rounded-2xl border border-white/10 bg-charcoal">
                  <div className="relative h-40">
                    <img src={profileImage} alt="Profile preview" className="h-full w-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                  </div>
                  <div className="p-4">
                    <p className="font-bold text-white">Marcus, 29</p>
                    <p className="text-xs text-silver">~0.4 km away · Active now</p>
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {['Friends', 'Dates', 'Community'].map((tag) => (
                        <span key={tag} className="rounded-full border border-primary/25 bg-primary/10 px-2.5 py-0.5 text-[0.65rem] font-bold text-accent">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-3 grid grid-cols-2 gap-2">
                  <button type="button" className="rounded-xl border border-primary/30 bg-primary/10 py-3 text-sm font-bold text-primary">
                    👋 Poke
                  </button>
                  <button type="button" className="rounded-xl bg-primary py-3 text-sm font-bold text-white">
                    💬 Chat
                  </button>
                </div>

                <div className="mt-3 flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/15 text-lg">📵</span>
                  <div className="text-xs leading-snug text-silver">
                    <strong className="block text-sm text-white">Screenshot blocked</strong>
                    Trust without forcing visibility
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -right-4 top-1/4 hidden rounded-2xl border border-white/10 bg-charcoal/90 px-4 py-3 shadow-card backdrop-blur md:block">
              <p className="text-[0.65rem] font-bold uppercase tracking-wider text-accent">Live nearby</p>
              <p className="text-lg font-black text-white">128+</p>
            </div>

            <div className="absolute -left-6 bottom-1/4 hidden rounded-2xl border border-primary/20 bg-primary/10 px-4 py-3 md:block">
              <p className="text-xs font-bold text-white">✓ Discreet verified</p>
            </div>
          </div>
        </div>
      </div>
    </HeroBackdrop>
  );
}

export default Hero;
